export default __webpack_public_path__ + "static/media/onboard_new_plant_white.b1396fd7.svg";